import { ChangeDetectorRef, Component } from '@angular/core';
import { TranslateFormatText } from '../../helpers/array.helpers';
import { TranslateHelper } from '../../helpers/injector.helper';
import { AgentService } from '../../services/agent.service';
import { BaseListDetail, BaseListSettings, DeleteTexts, SaveTexts } from '../base.list.settings';

@Component({
    selector: 'agent-settings',
    templateUrl: '../base.list.settings.html'
})
export class AgentSettings extends BaseListSettings {

    ShowAdd = true;
    ShowDelete = true;
    ShowRefresh = true;
    ShowSave = true;

    constructor(protected cdRef: ChangeDetectorRef, private service: AgentService) {
        super(cdRef);
    }

    getContentType() {
        return AgentDetail;
    }

    loadList(handler: any) {
        this.service.Get(null).subscribe((result) => {
            const list = [];
            result.forEach((entry: any) => {
                list.push({
                    Caption: entry.Caption,
                    ID: entry.SID,
                    IsCapsule: entry.IsCapsule,
                    IsOverridden: entry.IsOverridden
                });
            });
            handler(list);
        });
    }

    loadData(data: any) {
        this.service.GetByID(data).subscribe((result) => {
            if (result) {
                this.setSelectedItem(result);
            }
        });
    }

    getNewItem() {
        return {
            AgentName: TranslateHelper.TranslatorInstance.instant('@@Neue Agent Konfiguration'),
            MaximumAgentRequests: 25,
            MaximumServiceRequests: 25
        };
    }

    getDeleteText(sel: any): DeleteTexts {
        const retVal = new DeleteTexts();
        retVal.Question = new TranslateFormatText('@@Sind Sie sicher, dass Sie die Agent Konfiguration \'{0}\' loeschen moechten?');
        retVal.Question.FormatParams.push(sel.Caption);
        retVal.Success = new TranslateFormatText('@@Agent Konfiguration \'{0}\' erfolgreich geloescht.');
        retVal.Success.FormatParams.push(sel.Caption);
        retVal.Title = new TranslateFormatText('@@Agent Konfiguration loeschen');
        return retVal;
    }

    getSaveSuccessText(sel: any): SaveTexts {
        const retVal = new SaveTexts();
        retVal.Text = new TranslateFormatText('@@Agent Konfiguration \'{0}\' erfolgreich gespeichert.');
        retVal.Text.FormatParams.push(sel.AgentName);
        retVal.Title = new TranslateFormatText('@@Agent Konfiguration speichern');
        return retVal;
    }

    delete(data: any, handler: any) {
        this.service.Delete(data).subscribe((result) => {
            handler(result);
        });
    }

    saveInternal(item: any, handler: any) {
        this.service.Save(item).subscribe((result) => {
            if (result) {
                handler(result, result.SID, result.Caption);
            }
        });
    }

    handleNew(item: any, result: any) {
        item.SID = result.SID;
        item.Version = result.Version;
    }

    updateListItem(item: any, result: any) {
        item.IsCapsule = result.IsCapsule;
        item.IsOverridden = result.IsOverridden;
    }

    static GetSettingsEntry() {
        return {
            Caption: '@@Agent',
            ID: 'agent',
            Icon: 'bot',
            Index: 40,
            Parent: 'data',
            Security: {
                Name: 'evidanza.App.Shared.Security.DataRight',
                Value: 32768
            },
            Content: AgentSettings
        };
    }
}

@Component({
    selector: 'agent-detail',
    templateUrl: './agent.settings.html',
    styleUrls: ['./agent.settings.css']
})
export class AgentDetail extends BaseListDetail {
    Rows = [];

    constructor(private service: AgentService) {
        super();
    }

    setSelectedItem(item: any) {
        this.Rows = [];
        if (item && item.SID) {
            this.service.GetLogs(item.SID).subscribe(x => {
                if (x) {
                    this.Rows = x;
                    this.cdRef.detectChanges();
                }
            });
        }
        super.setSelectedItem(item);
    }

    DownloadConfig() {
        this.service.GetConfigFile(this.SelectedItem.SID).subscribe(x => {
            if (x) {
                var dataStr = "data:text/json;charset=UTF-8," + encodeURIComponent(x);
                var dlAnchorElem = document.getElementById('downloadAnchorElem');
                dlAnchorElem.setAttribute("href", dataStr);
                dlAnchorElem.setAttribute("download", "config_" + this.SelectedItem.AgentName + ".json");
                dlAnchorElem.click();
            }
        });      
    }
}
